// extracted by mini-css-extract-plugin
export default {"switcher":"switcher--1L6iW","active":"active--3DVpR"};
    if(module.hot) {
      // 1747648170065
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  